import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { ColDef, ColGroupDef } from 'ag-grid-community';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { map, Observable, of } from 'rxjs';
import { API_URL } from 'src/app/app.contant';
import { IAPIResponse } from '../../shared/models';
import { CustomFormFieldService } from '../../shared/services/form-field.service';
import { EncryptionOptions } from 'jspdf';
import { EncryptionService } from '../../dashboard/services/encryption.service';

@Injectable({
  providedIn: 'root'
})
export class PoApproverHelperService {

  constructor(private _modalService: BsModalService,
    private _formFieldService : CustomFormFieldService,
    private http: HttpClient,
    private _encryptionService : EncryptionService,
    private _formBuilder : FormBuilder) { }

  public getPoApproverColumnDefs(): (ColDef | ColGroupDef)[] {
    const coldefs = [
      { headerName: 'line item#', field: 'line_item_number', resizable: true, filter: true, pinned: 'left' },
      { headerName: 'Supplier Name', field: 'vendor_name', resizable: true, filter: true, pinned: 'left' },
      { headerName: 'Final Offer', field: 'final_price', resizable: true, filter: true, pinned: 'left' },
      { headerName: 'Vendor #', field: 'vendor_code', resizable: true, filter: true, pinned: 'left' },
      { headerName: 'Item Category', field: 'item_category', resizable: true, filter: true },
      { headerName: 'Material Code/Service Code', field: 'material_code', resizable: true, filter: true },
      { headerName: 'Item Description', field: 'item_desc', resizable: true, filter: true },
      { headerName: 'GL Account', field: 'gl_account', resizable: true, filter: true },
      { headerName: 'Short Text', field: 'short_text', resizable: true, filter: true },
      { headerName: 'Material Group', field: 'matl_group', resizable: true, filter: true },
      { headerName: 'Quantity', field: 'quantity', resizable: true, filter: true },
      { headerName: 'Ordering Unit', field: 'ordering_unit', resizable: true, filter: true },
      { headerName: 'Price', field: 'price', resizable: true, filter: true },
      { headerName: 'Currency', field: 'currency', resizable: true, filter: true },
      { headerName: 'Delivery Date', field: 'delivery_date', resizable: true, filter: true },
      { headerName: 'Warranties', field: 'warranties', resizable: true, filter: true },
      { headerName: 'PO Text', field: 'material_master.po_text' },
      { headerName: 'Incoterms', field: 'incoterm_1', resizable: true, filter: true },
      { headerName: 'Incoterms Description', field: 'incoterm_2', resizable: true, filter: true },
      { headerName: 'Terms of payment', field: 'terms_of_payment', resizable: true, filter: true },
      { headerName: 'Vendor email1', field: 'vendor_email_1', resizable: true, filter: true }
    ];
    return coldefs;
  }

  public getPoColumnDefs(): (ColDef | ColGroupDef)[] {
    const coldefs = [
      { headerName: 'Line Item Number', field: 'line_item_number', resizable: true, filter: true, pinned: 'left' },
      { headerName: 'PO Number', field: 'po_number', resizable: true, filter: true, pinned: 'left' },
      /* { headerName: 'PO Status', field: 'po_status', resizable: true, filter: true, pinned: 'left' }, */
      { headerName: 'Delivery Status', field: 'delivery_status', resizable: true, filter: true },
      { headerName: 'Estimate Delivery Date', field: 'estimated_delivery_date', resizable: true, filter: true },
      { headerName: 'Final Offer', field: 'final_offer', resizable: true, filter: true },
      { headerName: 'Sales Person', field: 'sales_person', resizable: true, filter: true },
      { headerName: 'Supplier Name', field: 'supplier_name', resizable: true, filter: true },
      { headerName: 'Vendor Code', field: 'vendor_code', resizable: true, filter: true },
      { headerName: 'PO Quantity', field: 'po_quantity', resizable: true, filter: true }
    ];
    return coldefs;
  }

  public fetchPRDataForPOCreation(qesId: any, prId: any): Observable<IAPIResponse<any>> {
    return this.http.get<IAPIResponse<any>>(`${API_URL.QES_APPROVER.CREATE_PO}qesId=${this._encryptionService.encryptPayload(encodeURIComponent(qesId))}&prId=${this._encryptionService.encryptPayload(encodeURIComponent(prId))}`);
  }

  public getPOApproverList(po_number: any): Observable<IAPIResponse<any>> {
    return this.http.get<IAPIResponse<any>>(`${API_URL.PO_CREATE.FETCH_PO_APPROVER_LIST}po_number=${po_number}`);
  }

  public fetchPOApproverDetails(body: any): Observable<any> {
    return this.http.post<IAPIResponse<any>>(`${API_URL.PO_CREATE.FETCH_APPROVER_LIST}`, body);
  }

  public fetchPOhistory(body: any): Observable<IAPIResponse<any>> {
    return this.http.post<IAPIResponse<any>>(`${API_URL.PO_CREATE.FETCH_PO_HISTORY}`, body);
  }

  public getPODocumentType(): Observable<IAPIResponse<any>> {
    return this.http.get<IAPIResponse<any>>(`${API_URL.PO_CREATE.GET_DOCUMENT_TYPE}`);
  }

  public getPOShippingCode(): Observable<IAPIResponse<any>> {
    return this.http.get<IAPIResponse<any>>(`${API_URL.PO_CREATE.GET_PO_SHIPPING_CODE}`);
  }

  public getPOConditionType(): Observable<IAPIResponse<any>> {
    return this.http.get<IAPIResponse<any>>(`${API_URL.PO_CREATE.GET_PO_CONDITION_TYPE}`);
  }

  public getPOPackingCode(): Observable<IAPIResponse<any>> {
    return this.http.get<IAPIResponse<any>>(`${API_URL.PO_CREATE.GET_PO_PACKING_CODE}`);
  }

  // public getPOPartnerCode(): Observable<IAPIResponse<any>> {
  //   return this.http.get<IAPIResponse<any>>(`${API_URL.PO_CREATE.GET_PO_PARTNER_CODE}`);
  // }

  public getPOPartnerCode(): Observable<IAPIResponse<any>>{
    const res = {
          "status": 200, 
          "message": "Successfully fetched records", 
          "exception": "", 
          "data": ["2A", "2B", "2C", "2D", "CR", "DP", "GS", "OA", "PI", "VN", "YA", "ZU", "ZV", "ZY"]};
        return of(res);
  }


  public getConfirmationControls() :Observable<any>{
    const res = {
      "status": 200, 
      "message": "Successfully fetched records", 
      "exception": "", 
      "data": ["IND Or Ack tol.99", "IND Or Ack tol.99ESI", "Ord ack EDI PTO(PHW)", "Ord Ack tot 999", "Order ackn EDI w/ GR", "Order acknowl", "Order acknowl EDI", "Order acknowl EDI JP", "Order Acknowl PG SU", "PTD Conf"]};
    return of(res);
  }

  public getPOConfCtrl(): Observable<IAPIResponse<any>> {
    return this.http.get<IAPIResponse<any>>(`${API_URL.PO_CREATE.GET_PO_CONF_CTRL}`);
  }

  public getPOClause(): Observable<IAPIResponse<any>> {
    return this.http.get<IAPIResponse<any>>(`${API_URL.PO_CREATE.GET_PO_CLAUSE}`);
  }

  public getPOGBK(): Observable<IAPIResponse<any>> {
    return this.http.get<IAPIResponse<any>>(`${API_URL.PO_CREATE.GET_PO_GBK}`);
  }

  public getPOYAPartner(): Observable<IAPIResponse<any>> {
    return this.http.get<IAPIResponse<any>>(`${API_URL.PO_CREATE.GET_PO_YA_PARTNER}`);
  }

  public fetchPoDetails(pr_number: string): Observable<IAPIResponse<any>> {
    return this.http.get<IAPIResponse<any>>(`${API_URL.PO_CREATE.FETCH_PO_LIST}prId=${pr_number}`);
  }

  public getPoDetailsForBuyer(po_number: string): Observable<IAPIResponse<any>> {
    return this.http.get<IAPIResponse<any>>(`${API_URL.PO_CREATE.FETCH_PO_DETAILS_FOR_BUYER}po_number=${po_number}`);
  }

  public getPoChangesForBuyer(po_number:any, item_number:any): Observable<IAPIResponse<any>> {
    if(item_number == null ){
      return this.http.get<IAPIResponse<any>>(`${API_URL.PO_CREATE.FETCH_PO_DETAILS_FOR_BUYER}po_number=${po_number}`);
    } else {
      return this.http.get<IAPIResponse<any>>(`${API_URL.PO_CREATE.FETCH_PO_DETAILS_FOR_BUYER}po_number=${this._encryptionService.encryptPayload(po_number)}&item_number=${this._encryptionService.encryptPayload(item_number)}`);
    }
  }
  public appendLineItem(pr_number:number, po_number:number, line_item_no:number): Observable<IAPIResponse<any>> {
      return this.http.get<IAPIResponse<any>>(`${API_URL.PO_CREATE.APPEND_LINEITEM}pr_number=${this._encryptionService.encryptPayload(pr_number)}&po_number=${this._encryptionService.encryptPayload(po_number)}&line_item_no=${this._encryptionService.encryptPayload(line_item_no)}`);
  }

  // public getPoChangesForBuyer(form_data?: any): Observable<any> {
  //   return this.http.get<IAPIResponse<any>>(`${API_URL.PO_CREATE.FETCH_PO_DETAILS_FOR_BUYER}`,form_data);
  // }

  public getPRDetailsForBuyer(prId: string): Observable<IAPIResponse<any>> {
    return this.http.get<IAPIResponse<any>>(`${API_URL.PO_CREATE.FETCH_PR_DETAILS_FOR_BUYER}${prId}`);
  }

  public createPO(prData: any, files: FormData, isBelowThreshold:boolean): Observable<IAPIResponse<any>> {
    const body = {
      files: files,
      prData: prData
    };
      return this.http.post<IAPIResponse<any>>(`${API_URL.PO_CREATE.CREATE_PO}`, files);
  }

  public confirmPO(files: FormData): Observable<IAPIResponse<any>> {
      return this.http.post<IAPIResponse<any>>(`${API_URL.SUPPLIER.PO_CONFIRMATION.CONFIRM_PO}`, files);
  }

  public downloadFile(refId: any, options?: any): Observable<any> {
    return this.http.get(`${API_URL.SUPPLIER.PO_CONFIRMATION.DOWNLOAD_FILE}${refId}`, {
        ...options,
        responseType: 'blob'  // Ensure the response is a binary file (blob)
    });
}
  public changePO(files: FormData): Observable<IAPIResponse<any>> {
      return this.http.post<IAPIResponse<any>>(`${API_URL.PO_CREATE.CHANGE_PO}`, files);
  }

  public fetchBelowThresholdPoValues(prId: any, vendors?: any){
    return this.http.post<IAPIResponse<any>>(`${API_URL.PO_CREATE.FETCH_PO_VENDOR}`,{prId:prId,vendor_details:vendors})
  }

  public getStorageLoaction(plant: string): Observable<IAPIResponse<any>> {
    return this.http.get<IAPIResponse<any>>(`${API_URL.PO_CREATE.FETCH_STORAGELOCATION}${(plant)}`);
  }

  public getItracerUserInfo(gid:any){
    return this.http.post<IAPIResponse<any>>(`${API_URL.FETCH_USER_INFO_BY_GID}`,gid)
  }

  public showPOconfirmationhistory(po_number:string,line_item_no:string){
    return this.http.get(`${API_URL.FETCH_PO_CONFIRMATION_HISTORY}?po_number=${this._encryptionService.encryptPayload(po_number)}&line_item_no=${this._encryptionService.encryptPayload(encodeURIComponent(line_item_no))}`)
  }

  public downloadReport(po_number: any): Observable<any> {
    return this.http.post<any>(`${API_URL.DOWNLOAD_REPORT}${this._encryptionService.encryptPayload(po_number)}`,{responseType: 'application/pdf' as any}); //testPDF
  }

  public getAllAttachments(prId:any,vendorCode:any){
    return this.http.get<any>(`${API_URL.FETCH_ALL_SUPPORTING_DOCS}${this._encryptionService.encryptPayload(prId)}&vendorCode=${this._encryptionService.encryptPayload(vendorCode)}`)
  }

  public poFieldHistoryUpdate(fieldList:any){
    return this.http.post(`${API_URL.PO_FIELDS_HISTORY}`,fieldList)
  }

  public saveLineItemData(lineItem:any){
    return this.http.post(`${API_URL.LINE_ITEM_DATA}`,lineItem)
  }

  public getPoFieldHistoryUpdate(prId:any){
    return this.http.get(`${API_URL.PO_FIELDS_HISTORY}?prId=${prId}`)
  }

  public updatePo(prId:number,po_number:string,line_item_no:any,remarks:string){
    return this.http.post<IAPIResponse<any>>(`${API_URL.PO_UPDATE.UPDATE_PO}`,{prId:prId,po_number:po_number,line_item_no:line_item_no,remarks:remarks})
  }

  public uploadNewLineItemDocs(formData:FormData, po_number:string){
    return this.http.post<IAPIResponse<any>>(`${API_URL.UPLOAD_NEW_LINEITEM_DOCS}?po_number=${this._encryptionService.encryptPayload(po_number)}`,formData)
  }

}  
